import { render, staticRenderFns } from "./TxMsg.vue?vue&type=template&id=6625419f&"
import script from "./TxMsg.vue?vue&type=script&lang=js&"
export * from "./TxMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports